<div class="blocked-container width-660" tracking formname="Smart invest line simulation"
  stepname="Block  user  unknown  partner" submittrigger="button.ab-unknown-partner-block" stepclusterOptional="stop">
  <div class="blocked-intro-text" [innerHTML]="'LoginAgnostic.IntroText' | translate | punctuationWrap"></div>
  <h2 class="blocked-title" [innerHTML]="'LoginAgnostic.Title' | translate | punctuationWrap"></h2>
  <div class="blocked-image">
    <img src="assets/images/itsme-blocking.svg" alt="Icon" />
  </div>
  <div class="blocked-content" [innerHTML]="'LoginAgnostic.Desc' | translate | punctuationWrap"></div>

  <div class="blocked-buttons fixed">
    <div class="cta-container">
      <div class="cta-btn-wrapper">
        <button class="btn btn-primary" [innerHTML]="'LoginAgnostic.RegisterBtn' | translate | punctuationWrap"
          (click)="navigate('register')"></button>
        <button class="btn btn-secondary" [innerHTML]="'LoginAgnostic.LoginBtn' | translate | punctuationWrap"
          (click)="navigate('login')"></button>

      </div>
    </div>
  </div>

</div>